<template>
  <div class="Header">
    <div class="logo">
      <a href="javascript:;">
        <img src="../assets/images/logo.png" alt="yly-logo" />
        <h1>{{myOption.name}}</h1>
      </a>
    </div>
    <ul class="logout">
<!--      <template v-if="$store.state.user.info.nickName">-->
        <li><a href="javascript:;" @click="setMyInfo">{{$store.state.user.info.nickName}}</a></li>
        <li>|</li>
<!--      </template>-->
      <template v-if="sysConfigPower">
        <li><a href="javascript:;" @click="openSysConfigDialog">系统配置</a></li>
        <li>|</li>
      </template>
      <template v-if="operatePower">
        <li><a href="javascript:;" @click="this.getOperate">运营配置</a></li>
        <li>|</li>
      </template>
      <template v-if="isRefresh">
        <li><a href="javascript:;" @click="refreshCache">刷新缓存</a></li>
        <li>|</li>
      </template>
      <li>
        <a href="javascript:;" @click="logout">退出</a>
      </li>
    </ul>
    <el-dialog title="修改个人信息" :visible.sync="isMyInfo" width="40%" center @close="resetForm('form')"  v-loading="isLoading">
      <el-form :model="form" :rules="rules" ref="form" label-width="66px">
        <el-form-item label="姓名" prop="name">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="passWord">
          <el-input v-model="form.passWord" show-password @input="setIsRequired"></el-input>
        </el-form-item>
        <el-form-item label="旧密码" prop="passWordOld">
          <el-input v-model="form.passWordOld" show-password @input="setIsRequired"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm('form')">提交</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog title="系统配置" :visible.sync="showSysConfigDialog" width="550px">
      <el-form ref="form" :model="sysConfigForm" label-width="115px">
        <el-form-item label="日志流开关">
          <el-switch v-model="logDetailConfig.enable" active-value="1" inactive-value="0"></el-switch>
        </el-form-item>
        <el-form-item label="日志流到期时间" :class="{'is-error':logDetailEndTimeError}" v-show="logDetailConfig.enable === '1'">
          <el-date-picker v-model="logDetailConfig.endTime" type="datetime" :pickerOptions="pickerOptions" placeholder="到期时间" @change="checkEndTime"></el-date-picker>
        </el-form-item>
        <el-form-item label="日志流采样率" :class="{'is-error':logDetailSamplingRateError}" v-show="logDetailConfig.enable === '1'">
          <el-input-number v-model="logDetailConfig.samplingRate" :precision="2" :step="0.05" :min="0.01" :max="100" placeholder="0~100"></el-input-number>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" v-if="sysConfigUpdatePower" @click="onSubmitSysConfig">确定</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog title="运营配置" :visible.sync="isOperateVisible" width="550px" center @close="resetForm('form')"  v-loading="isLoading">
      <el-form :model="form" :rules="rules" ref="form" label-width="220px" center>
        <el-form-item label="CTR预估冷启动周期" prop="ctrColdCycle">
          <el-input type="number" v-model.number="form.ctrColdCycle" size="medium" style="width: 200px" :disabled="!operateUpdatePower" onKeypress="return(/[\d]/.test(String.fromCharCode(event.keyCode)))">
            <div slot="append">分钟</div>
          </el-input>
          <el-tooltip class="item" effect="light" content="代码位+创意: 启动时长达到该时限后，CTR预估的冷启动结束。与点击数的冷启动结束阈值联动，满足其一则结束CTR预估" placement="right"><i class="el-icon-info"></i></el-tooltip>
        </el-form-item>
        <el-form-item label="CVR预估冷启动周期" prop="cvrColdCycle">
          <el-input type="number" v-model.number="form.cvrColdCycle" size="medium" style="width: 200px" :disabled="!operateUpdatePower" onKeypress="return(/[\d]/.test(String.fromCharCode(event.keyCode)))">
            <div slot="append">分钟</div>
          </el-input>
          <el-tooltip class="item" effect="light" content="代码位+创意: 启动时长达到该时限后，CVR预估的冷启动结束。与激活数的冷启动结束阈值联动，满足其一则结束CVR预估" placement="right"><i class="el-icon-info"></i></el-tooltip>
        </el-form-item>
        <el-form-item label="点击数的冷启动结束阈值" prop="clickThreshold">
          <el-input type="number" v-model.number="form.clickThreshold" size="medium" style="width: 200px" :disabled="!operateUpdatePower" onKeypress="return(/[\d]/.test(String.fromCharCode(event.keyCode)))">
            <div slot="append">次</div>
          </el-input>
          <el-tooltip class="item" effect="light" content="代码位+创意: 点击数达到该值后，CTR预估的冷启动结束。与CTR预估冷启动周期联动，满足其一则结束CTR预估" placement="right"><i class="el-icon-info"></i></el-tooltip>
        </el-form-item>
        <el-form-item label="激活数的冷启动结束阈值" prop="activateThreshold">
          <el-input type="number" v-model.number="form.activateThreshold" size="medium" style="width: 200px" :disabled="!operateUpdatePower" onKeypress="return(/[\d]/.test(String.fromCharCode(event.keyCode)))">
            <div slot="append">次</div>
          </el-input>
          <el-tooltip class="item" effect="light" content="代码位+创意: 激活数达到该值后，CVR预估的冷启动结束。与CVR预估冷启动周期联动，满足其一则结束CVR预估" placement="right"><i class="el-icon-info"></i></el-tooltip>
        </el-form-item>
        <el-form-item label="CTR冷启动阈值" prop="ctrThreshold">
          <el-input type="text" v-model="form.ctrThreshold" size="medium" style="width: 200px" :disabled="!operateUpdatePower" oninput="event.target.value = event.target.value.match(/^\d*(\.?\d{0,2})/gi)[0] || ''"></el-input>
          <el-tooltip class="item" effect="light" content="代码位+创意: 冷启动阶段的CTR阈值" placement="right"><i class="el-icon-info"></i></el-tooltip>
        </el-form-item>
        <el-form-item label="CVR冷启动阈值" prop="cvrThreshold">
          <el-input type="text" v-model="form.cvrThreshold" size="medium" style="width: 200px" :disabled="!operateUpdatePower" oninput="event.target.value = event.target.value.match(/^\d*(\.?\d{0,2})/gi)[0] || ''"></el-input>
          <el-tooltip class="item" effect="light" content="代码位+创意: 冷启动阶段的CVR阈值" placement="right"><i class="el-icon-info"></i></el-tooltip>
        </el-form-item>
        <el-form-item label="CTR预估周期" prop="ctrExpectedCycle">
          <el-input type="number" v-model.number="form.ctrExpectedCycle" size="medium" style="width: 200px" :disabled="!operateUpdatePower" onKeypress="return(/[\d]/.test(String.fromCharCode(event.keyCode)))">
            <div slot="append">分钟</div>
          </el-input>
          <el-tooltip class="item" effect="light" content="代码位+创意: CTR预估的取数时间周期(最大1440分钟)，每分钟更新一次CTR" placement="right"><i class="el-icon-info"></i></el-tooltip>
        </el-form-item>
        <el-form-item label="CVR预估周期" prop="cvrExpectedCycle">
          <el-input type="number" v-model.number="form.cvrExpectedCycle" size="medium" style="width: 200px" :disabled="!operateUpdatePower" onKeypress="return(/[\d]/.test(String.fromCharCode(event.keyCode)))">
            <div slot="append">分钟</div>
          </el-input>
          <el-tooltip class="item" effect="light" content="代码位+创意: CVR预估的取数时间周期(最大1440分钟)，每分钟更新一次CVR" placement="right"><i class="el-icon-info"></i></el-tooltip>
        </el-form-item>
        <el-form-item label="广告填充概率" prop="adFillRate">
          <el-input type="number" v-model.number="form.adFillRate" size="medium" style="width: 200px" :disabled="!operateUpdatePower" onKeypress="return(/[\d]/.test(String.fromCharCode(event.keyCode)))"></el-input>
          <el-tooltip class="item" effect="light" content="DSP参竞概率" placement="right"><i class="el-icon-info"></i></el-tooltip>
        </el-form-item>
        <el-form-item v-if="operateUpdatePower">
          <el-button type="primary" @click="setOperate">提交</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import sysConfigAPI from '../api/sysConfig'

export default {
  name: 'Header',
  thisModule: [],
  data () {
    return {
      sysConfigPower: false,
      sysConfigUpdatePower: false,
      showSysConfigDialog: false,
      sysConfigForm: {
        logDetailConf: {
          id: '',
          key: ''
        }
      },

      logDetailEndTimeError: false,
      logDetailSamplingRateError: false,
      logDetailConfig: {
        enable: 0,
        endTime: '',
        samplingRate: ''
      },

      pickerOptions: {
        disabledDate: (time) => this.$utils.disabledDate(time)
      },

      operatePower: false,
      operateUpdatePower: false,
      isOperateVisible: false,
      isRefresh: false,
      isLoading: false,
      isMyInfo: false,
      isRequired: false,
      form: {
        name: '',
        passWord: '',
        passWordOld: '',
        ctrColdCycle: '',
        cvrColdCycle: '',
        clickThreshold: '',
        activateThreshold: '',
        ctrThreshold: '',
        cvrThreshold: '',
        ctrExpectedCycle: '',
        cvrExpectedCycle: '',
        adFillRate: ''
      },
      rules: {
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' },
          { min: 2, max: 16, message: '长度在 2 到 16 个字符', trigger: 'blur' }
        ],
        passWord: [
          { required: this.isRequired, message: '请输入新密码', trigger: 'blur' },
          { min: 6, max: 18, message: '长度在 6 到 18 个字符', trigger: 'blur' }
        ],
        passWordOld: [
          { required: this.isRequired, message: '请输入旧密码', trigger: 'blur' },
          { min: 6, max: 18, message: '长度在 6 到 18 个字符', trigger: 'blur' }
        ],
        ctrColdCycle: [
          { required: true, message: '请输入CTR预估冷启动周期', trigger: 'blur' }
        ],
        cvrColdCycle: [
          { required: true, message: '请输入CVR预估冷启动周期', trigger: 'blur' }
        ],
        clickThreshold: [
          { required: true, message: '请输入点击数的冷启动结束阈值', trigger: 'blur' }
        ],
        activateThreshold: [
          { required: true, message: '请输入激活数的冷启动结束阈值', trigger: 'blur' }
        ],
        ctrThreshold: [
          { required: true, message: '请输入CTR冷启动阈值', trigger: 'blur' }
        ],
        cvrThreshold: [
          { required: true, message: '请输入CVR冷启动阈值', trigger: 'blur' }
        ],
        ctrExpectedCycle: [
          { required: true, message: '请输入CTR预估周期', trigger: 'blur' }
        ],
        cvrExpectedCycle: [
          { required: true, message: '请输入CVR预估周期', trigger: 'blur' }
        ],
        adFillRate: [
          { required: true, message: '请输入广告填充率', trigger: 'blur' }
        ]
      }
    }
  },
  created () {
    // 获取模块配置
    let thisModule = this.myOption.requestModule.cache.children
    // 获取功能权限
    this.$store.dispatch('GetPowerList').then((powers) => {
      // 刷新缓存
      if (powers[800] && (powers[800].powerValue & thisModule.refresh.power) === thisModule.refresh.power) {
        this.isRefresh = true
      }
      if (powers[1600] && (powers[1600].powerValue & this.myOption.requestModule.operate.children.list.power) === this.myOption.requestModule.operate.children.list.power) {
        this.operatePower = true
        if ((powers[1600].powerValue & this.myOption.requestModule.operate.children.update.power) === this.myOption.requestModule.operate.children.update.power) {
          this.operateUpdatePower = true
        }
      }

      let sysConfigModPower = powers[sysConfigAPI.MODULE.id]
      if (sysConfigModPower && ((sysConfigModPower.powerValue & sysConfigAPI.MODULE.list.power) === sysConfigAPI.MODULE.list.power)) {
        this.sysConfigPower = true
        if ((sysConfigModPower.powerValue & sysConfigAPI.MODULE.update.power) === sysConfigAPI.MODULE.update.power) {
          this.sysConfigUpdatePower = true
        }
      }
    })
    this.thisModule = thisModule
  },
  methods: {
    // 退出
    logout () {
      this.$axios({
        method: 'post',
        headers: {
          'Authorization': this.$store.state.user.token
        },
        url: this.myOption.requestUrl + '/logout'
      }).then(res => {
        const code = res.data.code
        if (res.data.code === 200) {
          this.$router.push({path: '/login'})
        } else {
          this.myOption.abnormalCode(this, code)
        }
      }).catch((err) => {
        this.myOption.abnormalCode(this, err)
      })
    },
    // 刷新缓存
    refreshCache () {
      this.$axios({
        method: 'post',
        headers: {
          'Authorization': this.$store.state.user.token,
          'ModuleId': this.thisModule.refresh.id
        },
        url: this.myOption.requestUrl + this.thisModule.refresh.api
      }).then(res => {
        const code = res.data.code
        if (code === 200) {
          this.$message.success('刷新缓存成功')
        } else {
          this.myOption.abnormalCode(this, code)
        }
        this.isLoading = false
      }).catch((err) => {
        this.myOption.abnormalCode(this, err)
        this.isLoading = false
      })
    },
    // 修改个人信息
    setMyInfo () {
      if (this.$store.getters.isMediaOwner) {
        return false
      }
      this.$axios({
        method: 'post',
        headers: {
          'Authorization': this.$store.state.user.token,
          'ModuleId': 108
        },
        url: this.myOption.requestUrl + '/user/query/personal/info'
      }).then(res => {
        const code = res.data.code
        if (code === 200) {
          this.form.name = res.data.data.nickName
          this.isMyInfo = true
        } else {
          this.myOption.abnormalCode(this, code)
        }
      }).catch((err) => {
        this.myOption.abnormalCode(this, err)
      })
    },
    // 必填
    setIsRequired (value) {
      if (value !== '') {
        this.isRequired = true
      } else if (this.form.passWord === '' && this.form.passWordOld === '') {
        this.isRequired = false
        this.$refs.form.clearValidate('passWord')
        this.$refs.form.clearValidate('passWordOld')
      }
    },
    // 提交表单
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.isLoading = true
          let param = {
            nickName: this.form.name
          }
          if (this.form.passWord !== '') {
            param.passWord = this.form.passWord
            param.oldPassWord = this.form.passWordOld
          }
          this.$axios({
            method: 'post',
            headers: {
              'Authorization': this.$store.state.user.token,
              'ModuleId': 107
            },
            url: this.myOption.requestUrl + '/user/update/personal/info',
            data: this.qs.stringify(param)
          }).then((res) => {
            let code = res.data.code
            if (code === 200) {
              this.$message.success('修改个人信息成功')
              this.isMyInfo = false
              this.$router.push({path: '/login'})
            } else {
              this.myOption.abnormalCode(this, code)
            }
          }).catch((err) => {
            this.myOption.abnormalCode(this, err)
          })
        } else {
          return false
        }
      })
    },
    // 重置表单
    resetForm (formName) {
      this.$refs[formName].resetFields()
    },
    checkEndTime () {
      if (this.logDetailConfig.enable === '0') return true

      if (this.logDetailConfig.endTime) {
        if (this.$utils.isPastTime(this.logDetailConfig.endTime)) {
          this.$message.error('到期时间不能早于当前时间')
          this.logDetailEndTimeError = true
          return false
        } else {
          this.logDetailEndTimeError = false
          return true
        }
      } else {
        this.$message.error('请选择到期时间')
        this.logDetailEndTimeError = true
        return false
      }
    },
    checkSamplingRate () {
      if (this.logDetailConfig.enable === '0') return true

      if (this.logDetailConfig.samplingRate) {
        if (this.logDetailConfig.samplingRate <= 0 || this.logDetailConfig.samplingRate > 100) {
          this.$message.error('0 < 采样率 ≤ 100, 支持两位小数')
          this.logDetailSamplingRateError = true
          return false
        } else {
          this.logDetailSamplingRateError = false
          return true
        }
      } else {
        this.$message.error('请填写采样率')
        this.logDetailSamplingRateError = true
        return false
      }
    },
    marshalling () {
      let conf = this.logDetailConfig
      if (conf.enable === '1') {
        return conf.enable + ',' + this.$utils.dateToUnixtime(conf.endTime) + ',' + conf.samplingRate
      }
      return '0'
    },
    unmarshalling () {
      let logDetailConfigStr = this.sysConfigForm.logDetailConf.value || ''
      let info = logDetailConfigStr.split(',')
      this.logDetailConfig = {
        enable: info[0] || 0,
        endTime: this.$utils.unixtimeToDate(info[1]) || null,
        samplingRate: info[2] || 100
      }
    },
    openSysConfigDialog () {
      sysConfigAPI.getList().then(res => {
        this.sysConfigForm.logDetailConf = res.data.find(item => item.key === 'log_detail_conf') || {}
        this.unmarshalling()
        this.showSysConfigDialog = true
      })
    },
    onSubmitSysConfig () {
      if (this.checkEndTime() && this.checkSamplingRate()) {
        sysConfigAPI.update({
          id: this.sysConfigForm.logDetailConf.id,
          key: this.sysConfigForm.logDetailConf.key,
          value: this.marshalling(),
          remark: this.sysConfigForm.logDetailConf.remark
        }).then(res => {
          this.showSysConfigDialog = false
          this.$message.success('操作成功')
        })
      }
    },
    // 获取运营配置
    getOperate () {
      this.$axios({
        method: 'post',
        headers: {
          'Authorization': this.$store.state.user.token,
          'ModuleId': this.myOption.requestModule.operate.children.list.id
        },
        url: this.myOption.requestUrl + this.myOption.requestModule.operate.children.list.api
      }).then(res => {
        const code = res.data.code
        if (code === 200) {
          this.form.ctrColdCycle = res.data.data.ctrColdCycle
          this.form.cvrColdCycle = res.data.data.cvrColdCycle
          this.form.clickThreshold = res.data.data.clickThreshold
          this.form.activateThreshold = res.data.data.activateThreshold
          this.form.ctrThreshold = res.data.data.ctrThreshold
          this.form.cvrThreshold = res.data.data.cvrThreshold
          this.form.ctrExpectedCycle = res.data.data.ctrExpectedCycle
          this.form.cvrExpectedCycle = res.data.data.cvrExpectedCycle
          this.form.adFillRate = res.data.data.adFillRate
          this.isOperateVisible = true
        } else {
          this.myOption.abnormalCode(this, code)
        }
      }).catch((err) => {
        this.myOption.abnormalCode(this, err)
      })
    },
    setOperate () {
      this.$confirm('此操作将修改运营配置, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$refs['form'].validate((valid) => {
          if (valid) {
            this.isLoading = true
            this.$axios({
              method: 'post',
              headers: {
                'Authorization': this.$store.state.user.token,
                'ModuleId': this.myOption.requestModule.operate.children.update.id
              },
              url: this.myOption.requestUrl + this.myOption.requestModule.operate.children.update.api,
              data: this.qs.stringify({
                ctrColdCycle: this.form.ctrColdCycle,
                cvrColdCycle: this.form.cvrColdCycle,
                clickThreshold: this.form.clickThreshold,
                activateThreshold: this.form.activateThreshold,
                ctrThreshold: this.form.ctrThreshold,
                cvrThreshold: this.form.cvrThreshold,
                ctrExpectedCycle: this.form.ctrExpectedCycle,
                cvrExpectedCycle: this.form.cvrExpectedCycle,
                adFillRate: this.form.adFillRate
              })
            }).then((res) => {
              let code = res.data.code
              if (code === 200) {
                this.$message.success('修改运营配置成功')
                this.isOperateVisible = false
                this.isLoading = false
              } else {
                this.myOption.abnormalCode(this, code)
              }
            }).catch((err) => {
              this.myOption.abnormalCode(this, err)
            })
          } else {
            return false
          }
        })
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
  .Header{
    padding: 0 30px;
    height: 100%;
    background-color: #0f8bec;
    user-select: none;
  }
  .logo{
    float: left;
    font-size: 0;
  }
  .logo>a{
    display: block;
  }
  .logo>a>img{
    margin-right: 10px;
    vertical-align: middle;
  }
  .logo>a>h1{
    display: inline-block;
    font-size: 20px;
    color: #fff;
    letter-spacing: 1px;
    vertical-align: middle;
  }
  .logout{
    float: right;
  }
  .logout>li{
    float: left;
    padding: 0 6px;
    font-size: 14px;
    color: #fff;
    letter-spacing: 1px;
    cursor: pointer;
  }
  .logout>li>a{
    display: block;
    color: #fff;
  }
  .logout>li>a:hover{
    color: #fff;
  }
</style>
<style>
  .logo .el-dialog{
    width: 500px!important;
  }
</style>



// WEBPACK FOOTER //
// src/components/Header.vue